module.exports = __webpack_public_path__ + "static/media/Providing_digital_healthcare_through_a_GDPR-secure_telemedicine_software.1ef675aa.webp";